import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'

/**
 * usePetName — user_settings.pet_name を取得 (default: 「相棒」)
 *
 * 関連 spec: .company/departments/ux-design/2026-05-04-pet-companion-design-spec.md
 * 関連 decision: growth_events 64d50a56 (v4 関係性), d05b4d6e (v11)
 */
export function usePetName(): { name: string; loading: boolean } {
  const [name, setName] = useState('相棒')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let alive = true
    ;(async () => {
      try {
        const { data } = await supabase.from('user_settings').select('pet_name').limit(1).maybeSingle()
        if (alive && data?.pet_name) setName((data.pet_name as string) || '相棒')
      } catch {
        // fallback to default
      } finally {
        if (alive) setLoading(false)
      }
    })()
    return () => { alive = false }
  }, [])

  return { name, loading }
}
